export default "__VITE_ASSET__a436a6bf__"